import axiosInstance, { AxiosResponse } from '../axios';
import { WrapImsPacket } from 'store/utility';

/**
 * Retrieves iteration details of project of interest.
 *
 * @returns {Promise<AxiosResponse<object[]>>} array of iteration objects.
 */
export const getIterations = async () => {
	return await axiosInstance.get(`api/AzureDevOps/Iterations`);
};

/**
 * Retrieves details of work item of interest.
 * @param {Number} id identifier of work item of interest.
 * @param {string=} expand expand parameter for work item attributes
 * @returns {Promise<AxiosResponse<object>>} work item details.
 */
export const getWorkItem = async (id, expand) => {
	return await axiosInstance.get(`api/AzureDevOps/${id}`, {
		params: {
			expand: expand,
		},
	});
};

/**
 * Executes query represented by argument.
 * @param {Object} wiql work item query language object.
 * @returns {Promise<AxiosResponse<object[]>>} array of work item objects satisfying wiql criteria.
 */
export const postWIQL = async wiql => {
	return await axiosInstance.post(
		'api/AzureDevOps/WIQL',
		WrapImsPacket(wiql)
	);
};
